export default {
  setLoadingCourseSubscription: (state, courseId) => {
    state.loadingCourseSubscription = courseId;
  },
  setCourseSubscription: (state, updates) => {
    const idx = state.subscriptions.findIndex(
      (i) => i.campaign_id === updates.campaign_id
    );
    if (idx === -1) {
      state.subscriptions.push(updates);
    } else {
      state.subscriptions.splice(idx, 1, updates);
    }
  },
  setCourses: (state, { courses, schemaLevel }) => {
    courses = prepareLessons(courses, schemaLevel);
    state.courses = courses;
  },
  setLoadingSingleCourse: (state, loading) => {
    state.loadingSingleCourse = loading;
  },
  setLoadingCourses: (state, loading) => {
    state.loadingCourses = loading;
  },
};

const prepareLessons = (arr, schemaLevel) => {
  return arr
    .filter((i) => !!i.triggers_count)
    .map((course) => {
      if (schemaLevel) {
        course.schemaLevel = schemaLevel;
      }

      let triggers = [];

      (course.triggers || []).forEach(function (t) {
        if (t.type !== 'lesson') {
          return;
        }

        t.banner_img = t.banner_img || course.banner_img;
        triggers.push(t);
      });

      course.triggers = triggers;

      return course;
    });
};
